<script setup lang="ts">
  import { computed } from 'vue';
  import { HistoryRevisionList } from '@/features/Document';
  import { formatCivilDateToPtBR } from '@/shared/lib';
  import RecordReadModal from './RecordReadModal.vue';
  import type { RecordChangelogEntry, RecordModalTarget } from '../model/record-modal.types';

  /**
   * Changelog of a record, in read only. The revision of the target is the one of
   * the clicked row, and the list stops there: a previous revision cannot carry
   * what was changed after it.
   *
   * `entries` is the whole chain the server answered with, already fetched by whoever opens this
   * modal (armadilha 11 of HTMDOC-2426): fetching here, in `onMounted`, would open the modal before
   * knowing whether the request failed.
   */
  const props = defineProps<{
    target: RecordModalTarget;
    entries: RecordChangelogEntry[];
  }>();

  const emit = defineEmits<{
    close: [];
  }>();

  const items = computed(() =>
    props.entries
      .filter((entry) => entry.revision <= props.target.revision)
      .map((entry) => ({
        revision: entry.revision,
        dateLabel: formatCivilDateToPtBR(entry.date),
        changes: entry.changes,
      }))
  );
</script>

<template>
  <RecordReadModal
    modal-title="Histórico das Atualizações (changelog)"
    form-title="HISTÓRICO DAS ATUALIZAÇÕES"
    form-code="RQ05.2"
    form-revision-label="REV.03"
    :code="target.code"
    @close="emit('close')"
  >
    <HistoryRevisionList
      :items="items"
      empty-message="Nenhuma alteração registrada para este registro."
    />
  </RecordReadModal>
</template>
